import { useState } from 'react';
import { useIntl } from 'react-intl';
import Select from 'react-select';

import { importProduct } from '../services/ShopifyOrderCRUD';
import {
  ProductCategoryOption,
  productCategoryOptions,
} from '../../stock/models/ProductCategory';
import { toast } from 'react-toastify';

export default function ShopifyImport() {
  const intl = useIntl();
  const [productId, setProductId] = useState('');
  const [selectedCategory, setSelectedCategory] =
    useState<ProductCategoryOption | null>(null);
  const [loading, setLoading] = useState(false);

  async function onImportProduct() {
    if (!selectedCategory) {
      return;
    }
    try {
      setLoading(true);
      await importProduct(productId, selectedCategory.value);

      toast.success(intl.formatMessage({ id: 'shopifyImport.importSuccess' }));
    } catch (error) {
      if (error?.response?.data?.length > 0) {
        toast.error(error?.response?.data[0]);
      } else {
        toast.error(intl.formatMessage({ id: 'shopifyImport.importError' }));
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className="card p-10">
      <h1 className="card-title mb-4">
        {intl.formatMessage({ id: 'shopifyImport.importProducts' })}
      </h1>
      <label className="form-label mb-2">
        {intl.formatMessage({ id: 'shopifyImport.productId' })}
      </label>
      <input
        type="text"
        placeholder={intl.formatMessage({
          id: 'shopifyImport.productIdPlaceholder',
        })}
        className="form-control mb-4"
        value={productId}
        onChange={(e) => setProductId(e.target.value)}
      />
      <label className="form-label mb-2">
        {intl.formatMessage({ id: 'stock.category' })}
      </label>
      <Select
        className="react-select-container mb-4"
        classNamePrefix="react-select"
        isClearable
        options={productCategoryOptions}
        value={selectedCategory}
        onChange={(option) =>
          setSelectedCategory(option as ProductCategoryOption | null)
        }
        placeholder={intl.formatMessage({ id: 'stock.category' })}
      />
      <button
        className="btn btn-primary ms-auto"
        disabled={!productId || !selectedCategory || loading}
        onClick={onImportProduct}
      >
        {loading ? (
          <span className="spinner-border spinner-border-sm me-2"></span>
        ) : (
          <span className="fas fa-download me-2"></span>
        )}
        {intl.formatMessage({ id: 'shopifyImport.import' })}
      </button>
    </section>
  );
}
